import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
// import FrameworkTabs, { isFrameworkTab } from './FrameworkTabs';
import { Action, PageBody } from '../../components/aa';
import ClientIntake from './ClientIntake';

/*
 * The framework as a page of its own, scoped by the URL: with ?client_id= it is
 * that one client's, without it the version every new client inherits.
 *
 * The intake was taken off this page once, on the grounds that changing its
 * shape changes what every client's Orbit can reason about. That is true, and
 * it is still the super admin who owns the platform default; what it left
 * behind was a partner whose method asks something the default does not and no
 * way to say so. The field registry has carried a partner scope the whole time,
 * so this restores a control rather than opening one.
 *
 * The same tabs sit in the partner's own Settings, which has no client and so
 * always shows the version new clients inherit. This page is how one client's
 * version is reached, and every link that carries a client comes here.
 */

export const FrameworkPage: React.FC = () => {
  const [params] = useSearchParams();
  const clientName = params.get('client_name') || '';

  /* Parked with the intake tabs.
  const clientId = params.get('client_id') || '';
  const askedTab = params.get('tab') || '';
  const [tab, setTab] = useState(() => {
    if (isFrameworkTab(askedTab)) return askedTab;
    return 'opening';
  });

  const openTab = (next: string) => {
    setTab(next);
    const carried = new URLSearchParams(params);
    carried.set('tab', next);
    setParams(carried, { replace: true });
  };
  */

  /* Whoever sent the partner here says where they came from, so adjusting the
     framework is a step out and back rather than a page they have to escape.
     Only a path on this site is followed: a full URL here would be an open
     redirect wearing a Back button. */
  const asked = params.get('back') || '';
  let back = '';
  if (asked.startsWith('/') && !asked.startsWith('//')) back = asked;
  let backLabel = 'Back';
  if (clientName) backLabel = `Back to ${clientName}`;

  /* Parked with the intake tabs.
  let scopeLine = 'Every client you add inherits this, and so does a client who arrives through your link.';
  if (clientId) scopeLine = `Changes here reach ${clientName || 'this client'} and nobody else.`;
  */

  return (
    <PageBody>
      {back && (
        <div className="mb-4">
          <Action size="sm" variant="quiet" to={back} icon={<ArrowLeft size={14} />}>{backLabel}</Action>
        </div>
      )}
      {/* Replaced by the client intake: one intake for every role, fixed
          sections from Agents Anywhere and the partner's own below them.
      <PageHead
        eyebrow="Solution Partner"
        title="Intake framework."
        sub={`What a customer is asked when they self-register through your link, and the intake every client then goes through. ${scopeLine}`}
      />
      <FrameworkTabs clientId={clientId} clientName={clientName} tab={tab} onTab={openTab} />
      */}
      <ClientIntake />
    </PageBody>
  );
};

export default FrameworkPage;
